module.exports = __webpack_public_path__ + "06_hair_black.83a866c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/06_hair_black.png
// module id = dW6y
// module chunks = 0